import { ActionsObservable, ofType, StateObservable } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { ChatService } from '../../../../coaching-base/chat.service';
import { Dependencies } from '../../../../store';
import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../teamschat-summary.action';

import { Load, loadResult } from './load.action';

export const loadEpic = (
    action: ActionsObservable<PayloadAction<ActionType, Load>>,
    state: StateObservable<any>,
    deps: Dependencies,
): Observable<any> =>
    action.pipe(
        ofType(ActionType.TEAMS_CALL__TCS__LOAD),
        mergeMap((act: PayloadAction<ActionType, Load>) => {
            const service = deps.injector.get<ChatService>(ChatService);

            return service.listChatSummary(act.payload.userId).pipe(
                map((ret) => {
                    return loadResult(
                        {
                            ...act.payload,
                            chatCategories: ret,
                        },
                        act.storePath,
                    );
                }),
                catchError((err) => {
                    console.log(err);
                    return of(null);
                }),
            );
        }),
    );
